import { activityBy } from "@/types/activityBy";

const activityColumnConfig = {
  [activityBy.unit]: [
    {
      key: "parentGroupName",
      labelKey: "locations.locationlevelfloor-singular",
      csvHeaderKey: "locations.locationlevelfloor-singular"
    },
    {
      key: "groupName",
      labelKey: "locations.locationlevelunit-singular",
      csvHeaderKey: "locations.locationlevelunit-singular"
    }
  ],
  [activityBy.jobRole]: [
    {
      key: "groupName",
      labelKey: "job-roles.singular",
      csvHeaderKey: "job-roles.singular"
    }
  ]
};

export function getActivityColumns(activity) {
  if (
    activity == null ||
    activity === "" ||
    (Array.isArray(activity) && activity.length === 0)
  ) {
    return [];
  }
  const columns = activityColumnConfig[activity];
  if (!columns) {
    throw new Error(`Unknown activityBy value: ${activity}`);
  }
  return columns;
}
